export const NAME = 'features';

export const AVAILABLE_FEATURES = [];
